/* tslint:disable */
/* eslint-disable */
export enum WorkDocxOutputFormatEnum {
  Docx = 'DOCX',
  Pdf = 'PDF'
}
